import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastNotificationService } from '..';

@Injectable()
export class FileSaverService {
  constructor(private toastNotificationService: ToastNotificationService) {}

  save(
    blob: ArrayBuffer,
    fileName: string,
    fileType: string,
    toastId?: number
  ): void {
    const newBlob = new Blob([blob], { type: fileType });

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const objectUrl = window.URL.createObjectURL(newBlob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;

    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    );

    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(objectUrl);
      link.remove();
    }, 100);

    if (toastId) {
      this.toastNotificationService.hide(toastId);
      this.toastNotificationService.success(
        $localize`:@@shared.fileSaverService.txtDownloaded:Download complete <br/> ${fileName}:fileName:`
      );
    }
  }

  saveFromUrl(url: string, fileName: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  }

  saveFromBytes(response: HttpResponse<ArrayBuffer>, toastId?: number): void {
    const fileType = response.headers.get('Content-Type');
    const disposition = response.headers.get('content-disposition');

    let fileName = '';
    const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = fileNameRegex.exec(disposition);

    if (matches != null && matches[1]) {
      fileName = matches[1].replace('utf-8', '').replace(/['"]/g, '');
      fileName = decodeURIComponent(fileName);
    }

    this.save(response.body, fileName, fileType, toastId);
  }
}
